var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-quiz"},[(_vm.$store.state.event.status)?_c('event-message'):_c('event-map')],1)}
var staticRenderFns = []

export { render, staticRenderFns }